import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import { Toaster } from "./components/ui/toaster";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Services from "./pages/Services";
import Book from "./pages/Book";
import Wellness from "./pages/Wellness";
import Programs from "./pages/Programs";
import Reviews from "./pages/Reviews";
import Events from "./pages/Events";
import Videos from "./pages/Videos";
import Community from "./pages/Community";
import Discover from "./pages/Discover";
import SacredAiko from "./pages/SacredAiko";
import About from "./pages/About";
import Contact from "./pages/Contact";
import FAQ from "./pages/FAQ";
import Policy from "./pages/Policy";
import Game from "./pages/Game";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import Admin from "./pages/Admin";
import Account from "./pages/Account";
import BecomeAmbassador from "./pages/BecomeAmbassador";
import AmbassadorLogin from "./pages/AmbassadorLogin";
import AmbassadorDashboard from "./pages/AmbassadorDashboard";
import Arcade from "./pages/Arcade";
import GiftCards from "./pages/GiftCards";
import SacredConnections from "./pages/SacredConnections";
import SCSafety from "./pages/SCSafety";
import SCOnboarding from "./pages/SCOnboarding";
import SCProfile from "./pages/SCProfile";
import SCDiscover from "./pages/SCDiscover";
import SCMatches from "./pages/SCMatches";
import SCSettings from "./pages/SCSettings";
import SCMessages from "./pages/SCMessages";
import SCAdmin from "./pages/SCAdmin";
import AdminResetPassword from "./pages/AdminResetPassword";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CartProvider>
          <ScrollToTop />
          <Navbar />
          <CartDrawer />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/services" element={<Services />} />
              <Route path="/gift-cards" element={<GiftCards />} />
              <Route path="/book" element={<Book />} />
              <Route path="/wellness" element={<Wellness />} />
              <Route path="/programs" element={<Programs />} />
              <Route path="/programs/:slug" element={<Programs />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/events" element={<Events />} />
              <Route path="/videos" element={<Videos />} />
              <Route path="/community" element={<Community />} />
              <Route path="/discover" element={<Discover />} />
              <Route path="/chakra-healing" element={<Navigate to="/wellness" replace />} />
              <Route path="/sacred-aiko" element={<SacredAiko />} />
              <Route path="/game" element={<Game />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/policy/:slug" element={<Policy />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/account" element={<Account />} />
              <Route path="/ambassador" element={<BecomeAmbassador />} />
              <Route path="/ambassador/login" element={<AmbassadorLogin />} />
              <Route path="/ambassador/dashboard" element={<AmbassadorDashboard />} />
              <Route path="/arcade" element={<Arcade />} />
              <Route path="/sacred-connections" element={<SacredConnections />} />
              <Route path="/sacred-connections/safety" element={<SCSafety />} />
              <Route path="/sacred-connections/onboarding" element={<SCOnboarding />} />
              <Route path="/sacred-connections/profile" element={<SCProfile />} />
              <Route path="/sacred-connections/discover" element={<SCDiscover />} />
              <Route path="/sacred-connections/matches" element={<SCMatches />} />
              <Route path="/sacred-connections/settings" element={<SCSettings />} />
              <Route path="/sacred-connections/messages" element={<SCMessages />} />
              <Route path="/admin/sacred-connections" element={<SCAdmin />} />
              <Route path="/admin/reset-password" element={<AdminResetPassword />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
          <Footer />
          <Toaster />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
